exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{background-color:#fff;color:#fff;font-family:Ubuntu Mono,Helvetica,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;margin:0}#app{margin:0 auto;max-width:270px;color:#34495e}h1{text-transform:uppercase;font-size:3em}.restart,h1{font-weight:700}.restart{background-color:#e74c3c;color:#fff;border:0;border-bottom-left-radius:10px;border-bottom-right-radius:10px;font-family:Ubuntu Mono,Helvetica,sans-serif;font-size:1.4em;margin:0;padding:15px;width:100%}.restart:hover{background-color:#c0392b;cursor:pointer}.scoreBoard{display:flex;flex-direction:row;justify-content:space-around;align-items:center;width:100%;height:15px;background-color:#16a085;box-shadow:10px solid #fff;padding:20px;overflow-x:none}.scoreBoard h2{margin:0}.scoreBoard span{float:right;font-size:1.5em;font-weight:700;margin-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a3fd4556","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 14
// module chunks = 0